import { jsx as _jsx } from "react/jsx-runtime";
import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import * as React from 'react';
import { TimezoneContext } from '../date-picker/provider';
import { fromMomentToZonedDateTime, toMoment, useDateSlotProps } from '../date-picker/utils';
import { TextField } from '../textfield';
import { DESKTOP_MEDIA_QUERY } from '../theme';
import { withVersion } from '../utils';
export const DateTimePicker = withVersion((props) => {
    const { timezone } = React.useContext(TimezoneContext);
    const { value, minDate, minDateTime, minTime, maxDate, maxDateTime, maxTime, referenceDate, skeleton, size = 'small', width = '100%', onChange, ...muiProps } = props;
    const slotProps = useDateSlotProps({
        ...props,
        size,
        width
    });
    if (skeleton) {
        return _jsx(TextField, { width: width, skeleton: true });
    }
    return (_jsx(MuiDateTimePicker, { ...muiProps, ...slotProps, desktopModeMediaQuery: DESKTOP_MEDIA_QUERY, sx: { width: '100%', ...muiProps.sx }, value: toMoment.nullable(value), minDate: toMoment(minDate), minDateTime: toMoment(minDateTime), minTime: toMoment(minTime), maxDate: toMoment(maxDate), maxDateTime: toMoment(maxDateTime), maxTime: toMoment(maxTime), referenceDate: toMoment(referenceDate), onChange: (date) => {
            const value = fromMomentToZonedDateTime(date, timezone);
            const clamped = value && minDateTime && value.isBefore(minDateTime)
                ? minDateTime
                : value;
            onChange?.(clamped);
        } }));
}, '1.0.0');
